import toast from "react-hot-toast";

export const showError = (message = "Error") => {
  toast.error(message, {
    style: {
      backgroundColor: "#fff",
      color: "#f43f5e",
      fontSize: "0.9rem",
      fontWeight: "600",
      borderRadius: "12px",
      padding: "12px 20px",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #fee2e2"
    },
  });
};

export const showSuccess = (message = "Success") => {
  toast.success(message, {
    style: {
      backgroundColor: "#fff",
      color: "#10b981",
      fontSize: "0.9rem",
      fontWeight: "600",
      borderRadius: "12px",
      padding: "12px 20px",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #d1fae5"
    },
  });
};
